/**
 * Plan tiers for the Surface Ops form (flowchart "Step 3").
 *
 * Enables the `.choose-a-plan-radio` choices from the counters filled in by
 * airport-search.js and the `.vehicle-count` field. With one FlightLine Y
 * airport, each priced tier is enabled up to its vehicle limit (Demo 2,
 * Lite 5, Intro 10). Anything else (several / unlisted / non-Y airports, or
 * over 10 vehicles) gets Core and Enterprise (Request a Quote) only.
 *
 * Also shows the Buy Now button only while the picked tier has a price
 * (`data-buy="1"` on its card, from lib/gravity-forms.php), and sets the
 * `.request-quote-tf` field to 1 for Buy Now, empty for Request a Quote.
 * Buy Now is switched off for now (BUY_NOW_ENABLED), so Request a Quote is
 * the only submit button.
 */

// Set to true to show Buy Now again.
const BUY_NOW_ENABLED = false;

// Most vehicles each priced tier covers.
const MAX_VEHICLES = { Demo: 2, Lite: 5, Intro: 10 };
const QUOTE = ['Core', 'Enterprise'];

/**
 * A GF field's input value (found by the field's CSS class) as a number, or
 * null if the form has no such field or it's empty.
 */
const fieldNumber = (form, selector) => {
  const input = form.querySelector(`${selector} input`);
  const value = input ? input.value.replace(/,/g, '').trim() : '';
  return value === '' ? null : Number(value);
};

/**
 * Tier choice values available for the form's answers.
 */
const availableTiers = (form) => {
  const airports = fieldNumber(form, '.airport-counter') || 0;
  const flightline = fieldNumber(form, '.flightline-counter') || 0;
  const unlisted = fieldNumber(form, '.unlisted-counter') || 0;
  const vehicles = fieldNumber(form, '.vehicle-count');

  if (airports !== 1 || flightline !== 1 || unlisted || !vehicles) {
    return QUOTE;
  }
  const priced = Object.keys(MAX_VEHICLES).filter((tier) => vehicles <= MAX_VEHICLES[tier]);
  return priced.length ? priced : QUOTE;
};

const setFieldValue = (form, selector, value) => {
  const input = form.querySelector(`${selector} input`);
  if (input) {
    input.value = value;
  }
};

/**
 * Enable / disable the tier choices for the form's answers, and show Buy Now
 * only for a picked tier with a price.
 */
const updatePlans = (form) => {
  const field = form && form.querySelector('.gfield.choose-a-plan-radio');
  if (!field) {
    return;
  }

  const enabled = new Set(availableTiers(form));
  field.querySelectorAll('input[type="radio"]').forEach((input) => {
    const off = !enabled.has(input.value);
    input.disabled = off;
    if (off) {
      input.checked = false;
    }
    const choice = input.closest('.gchoice');
    if (choice) {
      choice.classList.toggle('is-disabled', off);
    }
  });

  const checked = field.querySelector('input[type="radio"]:checked');
  const card = checked && checked.closest('.gchoice').querySelector('.tier_card');
  const buy = form.querySelector('.buy-now-button');
  if (buy) {
    buy.style.display = BUY_NOW_ENABLED && card && card.dataset.buy === '1' ? '' : 'none';
  }
};

const updateAll = () => {
  document.querySelectorAll('.gfield.choose-a-plan-radio').forEach((field) => updatePlans(field.closest('form')));
};

document.addEventListener('DOMContentLoaded', updateAll);

// Tier picks, vehicle count and the counters (airport-search.js fires change).
document.addEventListener('change', (event) => {
  updatePlans(event.target.form);
});

document.addEventListener('click', (event) => {
  const buy = event.target.closest('.buy-now-button');
  const submit = event.target.closest('[id^="gform_submit_button_"]');

  if (buy) {
    setFieldValue(buy.form, '.request-quote-tf', '1');
    const native = buy.form.querySelector('[id^="gform_submit_button_"]');
    if (native) {
      native.click();
    }
  } else if (submit && event.isTrusted) {
    // A real Request a Quote click (not Buy Now's synthetic one) clears the
    // flag, in case Buy Now was tried first and failed validation.
    setFieldValue(submit.form, '.request-quote-tf', '');
  }
});

if (window.jQuery) {
  // Re-run after AJAX submits / multi-page navigation re-render the form.
  window.jQuery(document).on('gform_post_render', updateAll);
}
